import { createSelector } from 'reselect'
import { getOptionFromState } from 'hocs/OptionsHOC/helpers'
const selectDevicebits = (state) => state.devicebits
const selectDevices = (state) => state.devices.devices
const selectRouting = (state) => state.routing

const selectCurrentPhoneId = createSelector(
  selectDevicebits,
  (devicebits) => devicebits.currentPhoneId
)

const selectLanguage = createSelector(
  selectDevicebits,
  (devicebits) => devicebits.language
)

const selectPhoneName = createSelector(
  selectDevicebits,
  (devicebits) => devicebits.currentPhoneName
)

const selectCurrentPhone = createSelector(
  selectCurrentPhoneId,
  selectDevices,
  (phoneId, deviceList) =>
    deviceList.find((device) => device.id === parseInt(phoneId, 10))
)

const selectRoutingKey = createSelector(
  selectRouting,
  (routing) => routing.locationBeforeTransitions.key
)

const selectQuery = createSelector(
  selectRouting,
  (routing) => routing.locationBeforeTransitions.query
)

const selectUser = createSelector(
  selectDevicebits,
  (devicebits) => devicebits.user
)

const selectShowCallHandler = createSelector(
  (state) => state,
  selectRouting,
  (state, routing) => {
    const getOption = getOptionFromState(state)
    const overlayEnabled =
      parseInt(routing.locationBeforeTransitions.query.overlay, 10) !== 0
    return getOption('callHandler.enabled') && overlayEnabled
  }
)

const selectLocation = createSelector(
  selectRouting,
  (routing) => routing.locationBeforeTransitions.pathname
)

const selectOptions = createSelector(selectDevicebits, (state) => state.options)

const selectIsFetching = createSelector(
  selectDevicebits,
  (state) => state.isFetching
)

const selectCustomerLabels = createSelector(
  selectDevicebits,
  (state) => state.customerLabels
)

export {
  selectCurrentPhoneId,
  selectCurrentPhone,
  selectShowCallHandler,
  selectPhoneName,
  selectLanguage,
  selectRoutingKey,
  selectUser,
  selectQuery,
  selectLocation,
  selectOptions,
  selectIsFetching,
  selectCustomerLabels
}
